import { css } from 'lit';

export default css`
  .c-card-header {
    display: flex;
    gap:  var(--rh-space-lg, 16px);
    align-items: center;
  }

  .c-card-header__title {
    flex: 1 1 auto;
    line-height: 0;
  }

  .c-card-header__icons {
    line-height: 0;
  }

  .c-card-header__icon {
    opacity: 0;
    margin-left: auto;
    animation: fadeIn 0.5s forwards;
    color: #4d4d4d;
    height: 24px;
    cursor: pointer;
  }

  .c-card-header__icon:hover, .c-card-header__icon:hover {
    color: #151515;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
